import { IFundingAccount, ITokenDetails } from '../../store/interface';
import { API_ROUTES_FOR_BINDER } from '../constants';
import utils, { IAPIHeaders } from '../utils';

export interface IAddWalletData {
  defaultFundingSource: boolean;
  fundingAccountToken: string;
  paymentNickName: string;
  fundingCategory: string;
  fundingAccountLastFourDigit: string;
  bankAccountType?: string;
  emailAddress?: null | string;
}

export interface IUpdateWalletData {
  defaultFundingSource: boolean;
  fundingAccountLastFourDigit: string;
  fundingAccountToken?: string;
  fundingCategory: string;
  nickName?: string;
  updatedCheckType?: string;
  updatedExpirationDate?: string;
  updatedFundingAccountType?: string;
  updatedZipcode?: string;
  bankAccountType?: string;
}

export interface IDeleteWalletData {
  fundingAccountToken: string;
  nickName?: string;
}

const { getUserSpecificAPIRoute } = utils;

const wallet = () => ({
  getWallets: (
    headers: IAPIHeaders,
    authDetails: ITokenDetails,
    userTypeCode: number,
    updateSchedulePaymentWalletData?: IFundingAccount | null,
  ) =>
    utils.fetch(`${getUserSpecificAPIRoute(userTypeCode).wallet.getWallets}`, {
      method: 'POST',
      data: {
        authorization: authDetails.token,
        messageId: authDetails.messageId,
        sessionToken: authDetails.session,
        requestTimeStamp: authDetails.timeStamp,
        fundingAccountSelectedPayment: updateSchedulePaymentWalletData,
      },
      headers,
    }),
  getBinderWallets: (
    headers: IAPIHeaders,
    authDetails: ITokenDetails,
    updateSchedulePaymentWalletData?: IFundingAccount | null,
  ) =>
    utils.fetch(`${API_ROUTES_FOR_BINDER.wallet.getWallets}`, {
      method: 'POST',
      data: {
        authorization: authDetails.token,
        messageId: authDetails.messageId,
        sessionToken: authDetails.session,
        requestTimeStamp: authDetails.timeStamp,
        fundingAccountSelectedPayment: updateSchedulePaymentWalletData,
      },
      headers,
    }),
  addWallet: (
    headers: IAPIHeaders,
    authDetails: ITokenDetails,
    addWalletData: IAddWalletData,
    userTypeCode: number,
  ) =>
    utils.fetch(`${getUserSpecificAPIRoute(userTypeCode).wallet.addWallet}`, {
      method: 'POST',
      data: {
        authorization: authDetails.token,
        defaultFundingSource: addWalletData.defaultFundingSource,
        fundingAccountToken: addWalletData.fundingAccountToken,
        messageId: authDetails.messageId,
        nickName: addWalletData.paymentNickName,
        requestTimeStamp: authDetails.timeStamp,
        sessionToken: authDetails.session,
        fundingCategory: addWalletData.fundingCategory,
        fundingAccountLastFourDigit: addWalletData.fundingAccountLastFourDigit,
        bankAccountType: addWalletData.bankAccountType,
        emailAddress: addWalletData.emailAddress,
      },
      headers,
    }),
  updateWallet: (
    headers: IAPIHeaders,
    authDetails: ITokenDetails,
    updateWalletData: IUpdateWalletData,
    userTypeCode: number,
  ) => {
    const {
      fundingCategory,
      fundingAccountToken,
      defaultFundingSource,
      updatedZipcode,
      updatedCheckType,
      updatedExpirationDate,
      updatedFundingAccountType,
      fundingAccountLastFourDigit,
      nickName,
      bankAccountType,
    } = updateWalletData;
    const { token, messageId, session: sessionToken, timeStamp } = authDetails;

    return utils.fetch(
      `${getUserSpecificAPIRoute(userTypeCode).wallet.updateWallet}`,
      {
        method: 'POST',
        data: {
          authorization: token,
          messageId: messageId,
          sessionToken,
          requestTimeStamp: timeStamp,
          nickName,
          fundingAccountLastFourDigit,
          fundingCategory,
          fundingAccountToken,
          defaultFundingSource,
          updatedZipcode,
          updatedCheckType,
          updatedExpirationDate,
          updatedFundingAccountType,
          bankAccountType,
        },
        headers,
      },
    );
  },

  deleteWalletPaymentMethod: (
    headers: IAPIHeaders,
    authDetails: ITokenDetails,
    deleteWalletData: IDeleteWalletData,
    userTypeCode: number,
  ) => {
    const { fundingAccountToken, nickName } = deleteWalletData;
    const { token, messageId, session: sessionToken, timeStamp } = authDetails;
    return utils.fetch(
      `${getUserSpecificAPIRoute(userTypeCode).wallet.deleteWallet}`,
      {
        method: 'POST',
        data: {
          authorization: token,
          sessionToken,
          requestTimeStamp: timeStamp,
          fundingAccountToken,
          messageId,
          nickName,
        },
        headers,
      },
    );
  },

  getFilteredWallets: (
    headers: IAPIHeaders,
    filterWallet: IFundingAccount | null,
    authDetails: ITokenDetails,
    userTypeCode: number,
  ) => {
    const { token, messageId, session: sessionToken, timeStamp } = authDetails;
    return utils.fetch(
      `${getUserSpecificAPIRoute(userTypeCode).wallet.viewFilteredWallet}`,
      {
        method: 'POST',
        data: {
          messageId,
          authorization: token,
          sessionToken,
          requestTimeStamp: timeStamp,
          fundingAccountSelectedPayment: filterWallet,
        },
        headers,
      },
    );
  },

  getFilteredWalletsBinder: (
    headers: IAPIHeaders,
    filterWallet: IFundingAccount | null,
    authDetails: ITokenDetails,
  ) => {
    const { token, messageId, session: sessionToken, timeStamp } = authDetails;
    return utils.fetch(`${API_ROUTES_FOR_BINDER.wallet.viewFilteredWallet}`, {
      method: 'POST',
      data: {
        messageId,
        authorization: token,
        sessionToken,
        requestTimeStamp: timeStamp,
        fundingAccountSelectedPayment: filterWallet,
      },
      headers,
    });
  },
});

export default wallet;
